import React from "react";
import ReactDOM from "react-dom/client";
import UploadFaktur from "./UploadFaktur";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <UploadFaktur />
        </React.StrictMode>
        );
        
